import {defaultLocale, locales} from '@i18n/config';
import TimeAgo, {LocaleData} from 'javascript-time-ago';
import ar from 'javascript-time-ago/locale/ar';
import bg from 'javascript-time-ago/locale/bg';
import cs from 'javascript-time-ago/locale/cs';
import da from 'javascript-time-ago/locale/da';
import de from 'javascript-time-ago/locale/de';
import el from 'javascript-time-ago/locale/el';
import en from 'javascript-time-ago/locale/en';
import es from 'javascript-time-ago/locale/es';
import fi from 'javascript-time-ago/locale/fi';
import fr from 'javascript-time-ago/locale/fr';
import hi from 'javascript-time-ago/locale/hi';
import hu from 'javascript-time-ago/locale/hu';
import id from 'javascript-time-ago/locale/id';
import it from 'javascript-time-ago/locale/it';
import ja from 'javascript-time-ago/locale/ja';
import ko from 'javascript-time-ago/locale/ko';
import ms from 'javascript-time-ago/locale/ms';
import nl from 'javascript-time-ago/locale/nl';
import no from 'javascript-time-ago/locale/no';
import pl from 'javascript-time-ago/locale/pl';
import pt from 'javascript-time-ago/locale/pt';
import ro from 'javascript-time-ago/locale/ro';
import ru from 'javascript-time-ago/locale/ru';
import sv from 'javascript-time-ago/locale/sv';
import th from 'javascript-time-ago/locale/th';
import tr from 'javascript-time-ago/locale/tr';
import uk from 'javascript-time-ago/locale/uk';
import vi from 'javascript-time-ago/locale/vi';
import zh from 'javascript-time-ago/locale/zh';

// prettier-ignore
const baseLocaleMapping: Record<string, LocaleData> = {
	ar, bg, cs, da, de, el, en, es, fi, fr, hi, hu, id, it,
	ja, ko, ms, nl, no, pl, pt, ro, ru, sv, th, tr, uk, vi, zh,
};

const loadedLocaleMapping: Record<string, LocaleData> = {};

for (const locale of locales) {
	const base = locale.includes('-') ? locale.split('-')[0] : locale;

	if (baseLocaleMapping[locale]) {
		loadedLocaleMapping[locale] = baseLocaleMapping[locale];
		continue;
	}

	if (baseLocaleMapping[base]) {
		loadedLocaleMapping[locale] = baseLocaleMapping[base];
		continue;
	}
}

/** Registers `javascript-time-ago` locale data for the active app locale (client-only). */
export function registerTimeAgoLocale(locale?: string | null): void {
	const resolved = locale || defaultLocale;
	if (!resolved || resolved.indexOf('.') > -1) {
		return;
	}

	const localePackage = loadedLocaleMapping[resolved];
	if (!localePackage) {
		console.error(`Failed to load javascript-time-ago locale: ${resolved}`);
		return;
	}

	TimeAgo.addLocale(localePackage);
}
